<template>
  <div>
    <h1>Set new password</h1>
    <ValidationObserver
      v-slot="{ invalid, passes }"
      ref="passwordFormObserver"
      tag="div"
    >
      <el-form
        v-loading="loading"
        ref="passwordForm"
        :model="form"
        label-position="top"
        novalidate
        @submit.native.prevent="passes(() => handleForm('passwordFormObserver'))">

        <form-alerts :messages="invalidMsg"/>

        <input
          :value="form.token"
          type="hidden"
          name="token">

        <ValidationProvider
          v-slot="{ errors }"
          :rules="rules.email"
          name="e-mail"
          vid="email"
          slim>
          <el-form-item
            :error="errors[0]"
            :required="checkRequired(rules.email)"
            label="E-mail">
            <el-input
              v-model="form.email"
              type="email"
              name="email"/>
          </el-form-item>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="rules.password_create"
          name="password"
          vid="password"
          slim>
          <el-form-item
            :error="errors[0]"
            :required="checkRequired(rules.password_create)"
            label="Password">
            <PasswordField
              id="password"
              v-model="form.password"
              :with-suggestions="true"
              name="password"/>
          </el-form-item>
        </ValidationProvider>

        <el-form-item>
          <el-button
            native-type="submit"
            type="primary">Set password
          </el-button>
        </el-form-item>
      </el-form>
    </ValidationObserver>
  </div>
</template>

<script>
  import forms from '@/shared/mixins/forms'
  import { postRequest } from '@/shared/utils/http'
  import PasswordField from '@/shared/components/PasswordField'
  import { rules } from './validation'

  export default {

    components: {
      PasswordField
    },

    mixins: [
      forms
    ],

    data: () => {
      return {
        rules,
        form: {
          email: window.email,
          password: '',
          token: window.token,
          password_confirmation: 'a'
        },
        passwordType: 'password'
      }
    },

    methods: {
      submitForm: function () {
        this.form.password_confirmation = this.form.password
        return new Promise((resolve, reject) => {
          postRequest('/password/reset', this.form)
            .then(response => {
              this.successMsg = response.msg
              if (response.intended) {
                window.location = response.intended
              }

              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/auth/pages/auth/Password.vue